import commonErrorMessages from '../../../../messages/common-messages/common-error.messages';
import unlockUserInsertUsernameMessages from '../../../../messages/unlock-user-messages/unlock-user-insert-username.messages';
import { ErrorMessages } from '../../../../model/error';
import { UnlockUserError } from './unlock-user-types';

export const messagesForUnlockUserError = (
  error: UnlockUserError
): ErrorMessages => {
  switch (error) {
    case 'GENERIC_ERROR':
      return {
        title: commonErrorMessages.errorTitleDefault,
        description: commonErrorMessages.errorDescriptionDefault,
      };
    case 'INVALID_CREDENTIALS':
      return {
        title: unlockUserInsertUsernameMessages.errorTitleInvalidCredentials,
      };
  }
};

export const verifyUnlockUserFields = (
  userCode: string
): UnlockUserError | undefined => {
  if (!userCode) {
    return 'INVALID_CREDENTIALS';
  } else {
    return undefined;
  }
};
